import Loadable from 'components/Loadable';
import {ENABLE_ANALYTICS, ENABLE_ISO_SURVEY} from 'configs/enable-features';
import {Redirect} from 'react-router';

const services = {
  path: '/services',
  component: Loadable({
    loader: () => import('../views/services'),
  }),
  routes: [
    {
      exact: true,
      path: '/services',
      component: () => <Redirect to="/services/api-certificate-search" />,
    },
    {
      path: '/services/api-certificate-search',
      component: Loadable({
        loader: () => import('../views/services/enterprise/landing'),
      }),
    },
    {
      path: '/services/certificate-search',
      component: Loadable({
        loader: () => import('../views/services/certificate-search/landing'),
      }),
    },
    {
      path: '/services/bulk-certificate-verification',
      component: Loadable({
        loader: () => import('../views/services/bulk-verification/landing'),
      }),
    },
    ENABLE_ANALYTICS && {
      path: '/services/certificate-market-intelligence',
      component: Loadable({
        loader: () => import('../views/services/market-intelligence/landing'),
      }),
    },
    ENABLE_ANALYTICS &&
      ENABLE_ISO_SURVEY && {
        path: '/services/iso-survey',
        component: Loadable({
          loader: () => import('../views/services/iso-survey/landing'),
        }),
      },
  ].filter((v) => v),
};

export default services;
